import React from 'react';
import { SelectHierarchyLabel } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import LoadingCard from '../../../../../../components/loadingCard';

const Selector = ({ key = 0, onSelect, onOpen = () => {}, form, tree, indexes, label, loading, multiple = true }) => {
    const { t } = useTranslation();
    const defaultLabel = t('attendees.printStock.selectRate.selectLabel');

    const options = tree
        .toOptions({
            filter: rate =>
                (rate.distributor === null || rate.distributor === undefined) &&
                Object.keys(indexes)
                    .map(rate_id => parseInt(rate_id))
                    .includes(rate.pk) &&
                rate.active,
            filterGroup: gr => gr.removed === null && (gr.children.length || gr.rates.length)
        })
        .filter(entry => (entry.children ? entry.children.length : entry));

    const handleChange = React.useCallback(
        selected => {
            const rates = selected.filter(id => indexes[id]).map(id => indexes[id]);
            onSelect(rates);
        },
        [onSelect, indexes]
    );

    const handleLabelChange = React.useCallback(selected => {
        return selected.length
            ? `${selected.length} ${
                  selected.length > 1
                      ? `${t('ticket.common.rates')} ${t('attendees.addAttendees.selectHierarchy.selectedPlural')} `
                      : `${t('ticket.common.rate')} ${t('attendees.addAttendees.selectHierarchy.selectedSingular')} `
              }`
            : '';
    }, []);

    const totalRates = React.useMemo(() => {
        let count = 0;
        options.forEach(gr => {
            if (gr.children?.length) {
                gr.children.forEach(r => {
                    count += 1;
                });
            } else {
                count = options.length;
            }
        });
        return count;
    }, [options]);

    if (loading) {
        return <LoadingCard loading />;
    }

    return (
        <SelectHierarchyLabel
            key={key}
            onOpen={onOpen}
            label={label || defaultLabel}
            placeholder={t('ticket.common.action.select')}
            placeholderSearch={t('ticket.common.action.search')}
            depth={0}
            height="maxi"
            labelSelectAll={t('attendees.addAttendees.selectHierarchy.label')}
            selected={form.selected_rates?.map(r => r.rateId)}
            onChange={handleChange}
            onLabelSelected={handleLabelChange}
            options={options}
            totalItems={totalRates}
            labelApply={t('ticket.common.action.select')}
            multi={multiple}
        />
    );
};

export default Selector;
